import { EventListData } from '~admin/model/event-list-data';
import { mapMediaData } from '~admin/model/media-data.mapper';
import { EventListResponseItem } from '~client/model/event-list-response-item';
import { datetime } from '~common/helper/datetime';

const mapEventData = (response: EventListResponseItem): EventListData => {
  const {
    announcement,
    defaultMedia,
    eventStartDate,
    eventEndDate,
    doorsOpenDate,
    state,
    id,
    shortName,
    vanityName,
  } = response;

  return {
    announcement,
    defaultMedia: mapMediaData(defaultMedia),
    eventName: shortName,
    eventStartDate: datetime.parse(eventStartDate),
    eventEndDate: datetime.parse(eventEndDate),
    doorsOpenDate: datetime.parse(doorsOpenDate),
    state,
    id,
    vanityName,
  };
};

export const mapEventListData = (response: EventListResponseItem[]): EventListData[] =>
  response.map(mapEventData);



// WEBPACK FOOTER //
// ./model/event-list-data.mapper.ts